module.exports = "https://cdn.hellotech.com/client-assets/tv_small_39f3451f708f3ff28c280859768db1b6.png";